import ApiAcces from "@/shared/services/ApiAcces";
import type IPlanService from "../contracts/IPlanService";
import type Plan from "../models/Plan";
import type Page from "@/shared/models/Page";
import type PageRequest from "@/shared/models/PageRequest";

export default class PlanService extends ApiAcces implements IPlanService {
  async getPlan(id: string): Promise<Plan> {
    return (await this.api.get(`/api/plan/${id}`)).data;
  }

  async getAllPlans(pageRequest: PageRequest): Promise<Page<Plan>> {
    return (await this.api.get("/api/plan", { params: pageRequest })).data;
  }

  async createPlan(plan: Omit<Plan, "id">): Promise<Plan> {
    return (await this.api.post("/api/plan", plan)).data;
  }

  async updatePlan(id: string, plan: Partial<Plan>): Promise<Plan> {
    return (await this.api.patch(`/api/plan/${id}`, plan)).data;
  }

  async deletePlan(id: string): Promise<void> {
    await this.api.delete(`/api/plan/${id}`);
  }
}
